/*
 * Cart drawer upsell "Add" buttons (.cd-upsell__form — plain product
 * forms, no <product-form> wrapper). Ported from the Litmus theme's
 * cart-upsell.js: add via /cart/add, then publish Dawn's cartUpdate so
 * <cart-drawer-items>.onCartUpdate() re-renders the item list, upsell and
 * footer (totals, savings) from the server. Delegated, so re-rendered
 * forms keep working; guarded so it installs once.
 */
(() => {
  if (window.__cartDrawerUpsell) return;
  window.__cartDrawerUpsell = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.cd-upsell__form');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    const setLoading = (loading) => {
      button.setAttribute('aria-disabled', loading ? 'true' : 'false');
      button.classList.toggle('is-loading', loading);
    };
    setLoading(true);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = new FormData(form);

    fetch(routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          setLoading(false);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'cart-upsell',
            productVariantId: form.querySelector('[name="id"]')?.value,
            errors: response.errors || response.description,
            message: response.message,
          });
          const errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = response.description || response.message || window.cartStrings?.error || '';
          return;
        }
        return CartItems.fetchCartData().then((cartData) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData });
        });
      })
      .catch(() => setLoading(false));
  });
})();
